module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "listWrapper"
  }, [_c('div', {
    staticClass: "listHeader"
  }, [_c('div', {
    staticClass: "listHeaderLeft"
  }, [(_vm.isExpanded) ? _c('span', {
    key: ("expanded_" + (_vm.list.id)),
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.isExpanded = false;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-down"
  })]) : _c('span', {
    key: ("collapsed_" + (_vm.list.id)),
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.isExpanded = true;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-arrow-right"
  })]), _vm._v(" "), (_vm.isBeingEdited) ? [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBeingEditedName),
      expression: "isBeingEditedName"
    }],
    domProps: {
      "value": (_vm.isBeingEditedName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.isBeingEditedName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon pointer",
    on: {
      "click": _vm.modifyNotificationList
    }
  }, [_c('i', {
    staticClass: "fas fa-check-circle"
  })]), _vm._v(" "), _c('span', {
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.isBeingEdited = !_vm.isBeingEdited;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])] : [_vm._v("\n                " + _vm._s(_vm.$t("notificationList.list")) + " " + _vm._s(_vm.list.name) + "\n            ")]], 2), _vm._v(" "), _c('div', {
    staticClass: "listHeaderRight"
  }, [_vm._v("\n            " + _vm._s(_vm.list.users.length) + " " + _vm._s(_vm.$t("notificationList.recipients")) + "\n            "), _c('span', {
    key: ("non_edit_" + (_vm.list.id)),
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.isBeingEdited = !_vm.isBeingEdited;
        _vm.isBeingEditedName = _vm.list.name;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-pencil-alt"
  })]), _vm._v(" "), _c('span', {
    key: ("non_edit_" + (_vm.list.id)),
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.deleteNotificationList(_vm.list);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isExpanded),
      expression: "isExpanded"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('SelectBloc', {
    attrs: {
      "value": _vm.list.application.id,
      "required": true,
      "options": _vm.applications,
      "label": 'Application'
    },
    on: {
      "change": function($event) {
        _vm.updateApplication(parseInt($event));
      }
    }
  })], 1), _vm._v(" "), _c('div', [_c('CheckboxGroupBloc', {
    attrs: {
      "name": 'zone',
      "label": 'Zones',
      "options": _vm.zonesForSelect,
      "value": _vm.selectedZonesForCheckboxes,
      "have-logo": false
    },
    on: {
      "input": _vm.updateZones
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "listHeader"
  }, [_c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFiltered),
      expression: "isFiltered"
    }],
    attrs: {
      "type": "radio",
      "id": "all"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isFiltered, false)
    },
    on: {
      "__c": function($event) {
        _vm.isFiltered = false
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "all"
    }
  }, [_vm._v(_vm._s(_vm.$t("notificationList.allUsers")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isFiltered),
      expression: "isFiltered"
    }],
    attrs: {
      "type": "radio",
      "id": "filtered"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isFiltered, true)
    },
    on: {
      "__c": function($event) {
        _vm.isFiltered = true
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "filtered"
    }
  }, [_vm._v(_vm._s(_vm.$t("notificationList.selectedRecipients")))]), _vm._v(" "), (_vm.list.id !== undefined) ? _c('span', {
    staticClass: "roundedIcon pointer",
    on: {
      "click": function($event) {
        _vm.isTooltipVisible = !_vm.isTooltipVisible;
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info"
  })]) : _vm._e()]), _vm._v(" "), (_vm.isTooltipVisible) ? _c('ul', {
    staticClass: "tooltip"
  }, [_c('li', [_vm._v("distribution list id " + _vm._s(_vm.list.id))]), _vm._v(" "), _c('li', [_vm._v("created by " + _vm._s(_vm.list.createdBy.lastname) + ", " + _vm._s(_vm.list.createdBy.firstname) + " (" + _vm._s(_vm.list.createdAt) + ")")]), _vm._v(" "), _c('li', [_vm._v("modified by " + _vm._s(_vm.list.modifiedBy.lastname) + ", " + _vm._s(_vm.list.modifiedBy.firstname) + " (" + _vm._s(_vm.list.modifiedDate) + ")")])]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_c('tbody', _vm._l((_vm.filteredUsers), function(user) {
    return _c('tr', {
      key: ((_vm.list.id) + "_" + (user.id))
    }, [_c('td', [_c('span', {
      staticStyle: {
        "text-transform": "uppercase"
      }
    }, [_vm._v(_vm._s(user.lastname))]), _vm._v(", "), _c('span', {
      staticStyle: {
        "text-transform": "capitalize"
      }
    }, [_vm._v(_vm._s(user.firstname))])]), _vm._v(" "), _c('td', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": _vm.isUserOnList(user)
      },
      on: {
        "click": function($event) {
          _vm.handleUser(user, _vm.list);
        }
      }
    })])])
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d31e012e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/notifcation-lists/NotificationListDetail.vue
// module id = 3374
// module chunks = 0